import React from "react"
import * as Icon from "react-feather"
import {faSignature} from "@fortawesome/free-solid-svg-icons/faSignature";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMoneyBillWave} from "@fortawesome/free-solid-svg-icons/faMoneyBillWave";
import {faChartLine} from "@fortawesome/free-solid-svg-icons/faChartLine";
import {
  faBell, faBomb,
  faBuilding,
  faCalendarAlt,
  faDesktop, faFile, faFunnelDollar, faHandHolding, faHome, faIdCard, faList,
  faLock,
  faMagic, faMoneyBillAlt, faMoneyBillWaveAlt, faMoneyCheck,
  faPlaceOfWorship, faShoppingBag, faTools, faTrademark, faUserPlus, faUsers,
  faUserSecret
} from "@fortawesome/free-solid-svg-icons";
import {faUser} from "@fortawesome/free-solid-svg-icons/faUser";
import {faLayerGroup} from "@fortawesome/free-solid-svg-icons/faLayerGroup";
import {faUserFriends} from "@fortawesome/free-solid-svg-icons/faUserFriends";

const navigationConfig = [
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <FontAwesomeIcon icon={faHome}/>,
    permissions: ["ADM","RRHH","GTE",'APR'],
    navLink: "/home"
  },

  {
    id: "users",
    title: "Usuarios",
    type: "item",
    icon: <FontAwesomeIcon icon={faUser}/>,
    permissions: ["ADM"],
    navLink: "/users"
  },


  {
    id: "operaciones",
    title: "Op. Pendientes",
    type: "item",
    icon: <FontAwesomeIcon icon={faMoneyBillAlt}/>,
    permissions: ["ADM"],
    navLink: "/operaciones"
  },

  {
    id: "historial",
    title: "Historial",
    type: "item",
    icon: <FontAwesomeIcon icon={faMoneyBillAlt}/>,
    permissions: ["ADM"],
    navLink: "/historial"
  },

    {
    id: "analisis_agente",
    title: "Analisis Agente",
    type: "item",
    icon: <FontAwesomeIcon icon={faChartLine}/>,
    permissions: ["ADM"],
    navLink: "/analisis_agente"
  },

   {
    id: "comisiones",
    title: "Analisis Comisiones",
    type: "item",
    icon: <FontAwesomeIcon icon={faChartLine}/>,
    permissions: ["ADM"],
    navLink: "/agentes_comisiones"
  },

  {
    id: "agentes",
    title: "Agentes",
    type: "item",
    icon: <FontAwesomeIcon icon={faChartLine}/>,
    permissions: ["ADM"],
    navLink: "/agentes"
  },

  {
    id: "dolar_ccl",
    title: "Dolar CCL",
    type: "item",
    icon: <FontAwesomeIcon icon={faFunnelDollar}/>,
    permissions: ["ADM"],
    navLink: "/dolar_ccl"
  },


]

export default navigationConfig
